import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { InstitutionSubscriptionModel } from '@shared/models/data/institution-subscription-model';

@Component({
  selector: 'aaos-subscriptions-table',
  templateUrl: './subscriptions-table.component.html',
  styleUrls: ['./subscriptions-table.component.scss']
})
export class SubscriptionsTableComponent implements OnInit {

  loading = true;
  dataSource: MatTableDataSource<InstitutionSubscriptionModel>;
  columnsToDisplay = ['benefitName', 'cycleStateName', 'cycleStartTime', 'expirationDate'];
  @Input() subscriptions: InstitutionSubscriptionModel[] = [];

  constructor() { this.dataSource = new MatTableDataSource(); }

  ngOnInit() {
    this.dataSource.data = this.subscriptions;
    this.loading = false;
  }

}
